/**
 * Admin Quiz Control Screen
 * Mobile interface for family admins to control live quiz sessions
 */

import React, { useCallback } from "react";
import { View, Text } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useLocalSearchParams, router } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";
import { AdminControlPanel } from "@/modules/quiz-live";

/**
 * Admin Quiz Control Route
 */
export default function AdminQuizControlRoute() {
  const colors = useThemeColors();
  const params = useLocalSearchParams<{ sessionId?: string; quizId?: string }>();
  const sessionId = params.sessionId;
  const quizId = params.quizId;
  
  /**
   * Handle close - go back
   */
  const handleClose = useCallback(() => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace("/(admin)/games/quiz" as any);
    }
  }, []);
  
  // If no session or quiz ID, show error
  if (!sessionId && !quizId) {
    return (
      <SafeAreaView 
        className="flex-1 items-center justify-center p-6"
        style={{ backgroundColor: colors.background }}
        edges={["top", "bottom"]}
      >
        <Text className="text-xl font-bold mb-2" style={{ color: colors.text }}>
          Geen quiz geselecteerd
        </Text>
        <Text className="text-center" style={{ color: colors.textSecondary }}>
          Selecteer een quiz om te starten of ga terug naar het overzicht.
        </Text>
      </SafeAreaView>
    );
  }
  
  return (
    <AdminControlPanel
      sessionId={sessionId}
      quizId={quizId}
      onClose={handleClose}
    />
  );
}

